(function () {
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Real coastlines, not a guess: LAND_MASK is a bit-packed, base64-encoded
     land/water flag for each point of a 12,000-point Fibonacci sphere,
     precomputed offline via point-in-polygon tests against Natural Earth's
     public-domain 1:110m land dataset (ne_110m_land.geojson). Regenerating
     the same sphere here and reading bit i tells us whether sphere point i
     falls on land — accurate to that dataset's resolution, ~29% of points
     flagged land which matches Earth's real land fraction. */
  var SPHERE_N = 12000;
  var LAND_MASK_B64 = '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';

  function decodeMask(b64) {
    var bin = atob(b64);
    var bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return bytes;
  }

  function bitSet(bytes, i) {
    return (bytes[i >> 3] & (1 << (i & 7))) !== 0;
  }

  function fibonacciSphere(n) {
    var pts = [];
    var goldenAngle = Math.PI * (3 - Math.sqrt(5));
    for (var i = 0; i < n; i++) {
      var y = 1 - (i / (n - 1)) * 2;
      var radius = Math.sqrt(Math.max(0, 1 - y * y));
      var theta = goldenAngle * i;
      pts.push([Math.cos(theta) * radius, y, Math.sin(theta) * radius]);
    }
    return pts;
  }

  function initGlobe(root) {
    if (root.hasAttribute('data-gp-globe-ready')) return;
    root.setAttribute('data-gp-globe-ready', 'true');

    var canvas = root.querySelector('canvas');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');

    var mask = decodeMask(LAND_MASK_B64);
    var sphere = fibonacciSphere(SPHERE_N);
    var isLand = new Uint8Array(SPHERE_N);
    var landPoints = [];
    for (var i = 0; i < sphere.length; i++) {
      if (bitSet(mask, i)) {
        isLand[i] = 1;
        landPoints.push(sphere[i]);
      }
    }

    /* Coastline outline, computed once here at init — never in the render
       loop. Every sphere point is bucketed into a coarse 3D grid over
       [-1,1]^3 so each adjacency test only looks at the 27 neighbouring
       cells (~180 candidates) instead of all 12,000 points. A land point
       whose neighbourhood contains water is a coastline point; each
       coastline point is then linked to its two nearest coastline
       neighbours, which traces the landmass edges closely enough. */
    var GRID_N = 24;
    var GRID_CELL = 2 / GRID_N;
    var NEAR_WATER = 0.055;
    var MAX_EDGE = 0.08;
    var coastEdges = [];

    function gridCoord(v) {
      var g = Math.floor((v + 1) / GRID_CELL);
      return g < 0 ? 0 : g > GRID_N - 1 ? GRID_N - 1 : g;
    }

    function gridKey(gx, gy, gz) {
      return (gx * GRID_N + gy) * GRID_N + gz;
    }

    function buildBuckets(indices) {
      var buckets = {};
      for (var b = 0; b < indices.length; b++) {
        var p = sphere[indices[b]];
        var k = gridKey(gridCoord(p[0]), gridCoord(p[1]), gridCoord(p[2]));
        if (buckets[k]) buckets[k].push(indices[b]);
        else buckets[k] = [indices[b]];
      }
      return buckets;
    }

    function forEachNeighbour(buckets, p, fn) {
      var gx = gridCoord(p[0]), gy = gridCoord(p[1]), gz = gridCoord(p[2]);
      for (var dx = -1; dx <= 1; dx++) {
        var x = gx + dx;
        if (x < 0 || x >= GRID_N) continue;
        for (var dy = -1; dy <= 1; dy++) {
          var y = gy + dy;
          if (y < 0 || y >= GRID_N) continue;
          for (var dz = -1; dz <= 1; dz++) {
            var z = gz + dz;
            if (z < 0 || z >= GRID_N) continue;
            var bucket = buckets[gridKey(x, y, z)];
            if (!bucket) continue;
            for (var n = 0; n < bucket.length; n++) {
              if (fn(bucket[n]) === false) return;
            }
          }
        }
      }
    }

    function buildCoastline() {
      var all = [];
      for (var a = 0; a < SPHERE_N; a++) all.push(a);
      var allBuckets = buildBuckets(all);

      var nearSq = NEAR_WATER * NEAR_WATER;
      var coast = [];
      for (var c = 0; c < SPHERE_N; c++) {
        if (!isLand[c]) continue;
        var p = sphere[c];
        var touchesWater = false;
        forEachNeighbour(allBuckets, p, function (j) {
          if (isLand[j]) return;
          var q = sphere[j];
          var ax = q[0] - p[0], ay = q[1] - p[1], az = q[2] - p[2];
          if (ax * ax + ay * ay + az * az <= nearSq) {
            touchesWater = true;
            return false;
          }
        });
        if (touchesWater) coast.push(c);
      }

      var coastBuckets = buildBuckets(coast);
      var maxSq = MAX_EDGE * MAX_EDGE;
      var seen = {};
      for (var e = 0; e < coast.length; e++) {
        var ci = coast[e];
        var cp = sphere[ci];
        var n1 = -1, d1 = Infinity, n2 = -1, d2 = Infinity;
        forEachNeighbour(coastBuckets, cp, function (j) {
          if (j === ci) return;
          var q = sphere[j];
          var ax = q[0] - cp[0], ay = q[1] - cp[1], az = q[2] - cp[2];
          var d = ax * ax + ay * ay + az * az;
          if (d > maxSq) return;
          if (d < d1) { d2 = d1; n2 = n1; d1 = d; n1 = j; }
          else if (d < d2) { d2 = d; n2 = j; }
        });
        if (n1 >= 0) addEdge(seen, ci, n1);
        if (n2 >= 0) addEdge(seen, ci, n2);
      }
    }

    function addEdge(seen, a, b) {
      var lo = a < b ? a : b;
      var hi = a < b ? b : a;
      var k = lo * SPHERE_N + hi;
      if (seen[k]) return;
      seen[k] = 1;
      coastEdges.push([sphere[lo], sphere[hi]]);
    }

    buildCoastline();

    var rotY = 0.4;
    var rotX = -0.2;
    var dragging = false;
    var lastX = 0;
    var lastY = 0;
    var autoSpeed = REDUCED_MOTION ? 0 : 0.0022;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var size = 0;

    function resize() {
      size = root.clientWidth || 340;
      canvas.width = size * dpr;
      canvas.height = size * dpr;
      canvas.style.width = size + 'px';
      canvas.style.height = size + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function project(p) {
      var cosY = Math.cos(rotY), sinY = Math.sin(rotY);
      var x1 = p[0] * cosY + p[2] * sinY;
      var z1 = -p[0] * sinY + p[2] * cosY;
      var cosX = Math.cos(rotX), sinX = Math.sin(rotX);
      var y2 = p[1] * cosX - z1 * sinX;
      var z2 = p[1] * sinX + z1 * cosX;
      return [x1, y2, z2];
    }

    function draw() {
      var r = size / 2 * 0.86;
      var cx = size / 2, cy = size / 2;
      ctx.clearRect(0, 0, size, size);

      ctx.beginPath();
      ctx.arc(cx, cy, r, 0, Math.PI * 2);
      ctx.strokeStyle = 'rgba(201, 166, 107, 0.22)';
      ctx.lineWidth = 1;
      ctx.stroke();

      for (var i = 0; i < landPoints.length; i++) {
        var rp = project(landPoints[i]);
        if (rp[2] < -0.05) continue;
        var px = cx + rp[0] * r;
        var py = cy - rp[1] * r;
        var depth = (rp[2] + 1) / 2;
        var alpha = 0.3 + depth * 0.65;
        var rad = 0.25 + depth * 0.45;
        ctx.beginPath();
        ctx.arc(px, py, rad, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(201, 166, 107, ' + alpha.toFixed(2) + ')';
        ctx.fill();
      }

      if (coastEdges.length) {
        ctx.beginPath();
        for (var e = 0; e < coastEdges.length; e++) {
          var ea = project(coastEdges[e][0]);
          if (ea[2] < -0.05) continue;
          var eb = project(coastEdges[e][1]);
          if (eb[2] < -0.05) continue;
          ctx.moveTo(cx + ea[0] * r, cy - ea[1] * r);
          ctx.lineTo(cx + eb[0] * r, cy - eb[1] * r);
        }
        ctx.strokeStyle = 'rgba(201, 166, 107, 0.42)';
        ctx.lineWidth = 0.5;
        ctx.stroke();
      }
    }

    function tick() {
      if (!dragging) rotY += autoSpeed;
      draw();
      requestAnimationFrame(tick);
    }

    function pointerDown(e) {
      dragging = true;
      lastX = e.clientX;
      lastY = e.clientY;
      root.classList.add('is-dragging');
      if (root.setPointerCapture && e.pointerId != null) {
        try { root.setPointerCapture(e.pointerId); } catch (err) {}
      }
    }

    function pointerMove(e) {
      if (!dragging) return;
      var dx = e.clientX - lastX;
      var dy = e.clientY - lastY;
      lastX = e.clientX;
      lastY = e.clientY;
      rotY += dx * 0.006;
      rotX = Math.max(-1.3, Math.min(1.3, rotX - dy * 0.006));
    }

    function pointerUp() {
      dragging = false;
      root.classList.remove('is-dragging');
    }

    root.addEventListener('pointerdown', pointerDown);
    root.addEventListener('pointermove', pointerMove);
    root.addEventListener('pointerup', pointerUp);
    root.addEventListener('pointerleave', pointerUp);
    root.addEventListener('pointercancel', pointerUp);

    root.addEventListener('keydown', function (e) {
      var step = 0.12;
      if (e.key === 'ArrowLeft') { rotY -= step; e.preventDefault(); }
      if (e.key === 'ArrowRight') { rotY += step; e.preventDefault(); }
      if (e.key === 'ArrowUp') { rotX = Math.max(-1.3, rotX - step); e.preventDefault(); }
      if (e.key === 'ArrowDown') { rotX = Math.min(1.3, rotX + step); e.preventDefault(); }
    });

    window.addEventListener('resize', resize);
    resize();
    draw();
    tick();
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-gp-globe]').forEach(initGlobe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
